// src/components/common/EnforcementOffLabel.jsx
//
// Shown beside a policy whose name or declared action says it blocks/enforces while its
// rules only alert or log (see utils/monitorMode.js for the condition).
import React from 'react';
import { ENFORCEMENT_OFF_LABEL } from '../../utils/monitorMode';

const VARIANTS = {
  light: 'bg-slate-100 text-slate-600 border-slate-300',
  dark: 'bg-slate-700/60 text-slate-300 border-slate-500/60',
};

const EnforcementOffLabel = ({ variant = 'light', className = '' }) => (
  <span
    data-testid="enforcement-off-label"
    title="The edge agent runs in monitor mode: this policy alerts, it does not block traffic."
    className={`inline-flex items-center whitespace-nowrap px-1.5 py-0.5 rounded border text-[10px] font-medium ${VARIANTS[variant] || VARIANTS.light} ${className}`}
  >
    {ENFORCEMENT_OFF_LABEL}
  </span>
);

export default EnforcementOffLabel;
